/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2026-10-28
 */

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSessionLogoutMutation, logout } from '../features/auth';
import { sanitizeErrorMessage } from '../utils/security';

/**
 * Hook for signing the user out (header menu and mobile menu).
 * Once the user is cleared, AppContent wipes their stored data and reloads
 * the app, so nothing from this user stays in the browser.
 */
export const useSignOut = () => {
  const dispatch = useDispatch();
  const [sessionLogout, { isLoading: isSigningOut }] =
    useSessionLogoutMutation();
  const [signOutError, setSignOutError] = useState('');

  const signOut = async () => {
    setSignOutError('');
    try {
      await sessionLogout().unwrap();
      dispatch(logout());
    } catch (error) {
      // On a network or server error the user stays signed in
      setSignOutError(sanitizeErrorMessage(error));
    }
  };

  return { signOut, isSigningOut, signOutError, setSignOutError };
};

export default useSignOut;
